import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { CreateManualTransferRecordDto, TransferDto } from '../types';

export const useCreateManualTransferRecord = (transferId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<TransferDto, Error, CreateManualTransferRecordDto>({
    mutationFn: (data) =>
      apiClient.post(`/v1/projects/${projectId}/transfers/${transferId}/records/manual`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
      queryClient.invalidateQueries({ queryKey: ['transfer', transferId] });
    },
  });
};
